import React from 'react';
import { Link } from 'react-router-dom';
import styles from './EntityLink.module.css';

interface EntityLinkProps {
  to: string;
  label: string;
  title?: string;
  className?: string;
}

export const EntityLink: React.FC<EntityLinkProps> = ({ to, label, title, className }) => {
  const combinedClassName = className
    ? `${styles.entityLink} ${className}`
    : styles.entityLink;

  return (
    <Link className={combinedClassName} to={to} title={title || label}>
      {label}
    </Link>
  );
};
